<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-default-page"/>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'wy-default-page',
  props: ["goto", 'reload'],

  computed: {
    ...mapGetters(['config']),
  },

  created() {      
    if(this.goto) {
      this.$router.push({ path: this.goto })
    }
    else if(this.reload) {
      this.$router.push({ path: this.reload })
    }
    else {
      setTimeout(() => { this.$router.push({ path: this.config.navMenu.defaultPath })}, 1000)
    }
  }
}
</script>